import React from 'react';
import { MetaInfoDescription } from './MetaInfoDescription';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ProfilePictureName } from '../../ProfilePictureName';
import { EditorialResponsibleProps } from '../MetaInfoPage';

type EditorialResponsibleMetaInfoProps = {
  editorialResponsible: EditorialResponsibleProps;
};

export function EditorialResponsibleMetaInfo({ editorialResponsible }: EditorialResponsibleMetaInfoProps) {
  const { t } = useSonTranslation('MetaInfo');
  return (
    <MetaInfoDescription className="invisible" term={t('editorialResponsible')}>
      <div className="page-meta-info__editorial-responsible">
        <ProfilePictureName
          profileLink={editorialResponsible.profileLink}
          profileName={editorialResponsible.profileName}
          profileImageUrl={editorialResponsible.profileImageUrl}
          personInfoCardUrl={editorialResponsible.personInfoCardUrl}
          editorialResponsible={t('editorialResponsible')}
        />
      </div>
    </MetaInfoDescription>
  );
}
